export default __webpack_public_path__ + "static/IOT_app-af0e44fed5c15830822657dbc6ed6944.png";